import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { PublicAnalytics } from "./components/PublicAnalytics";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found.");

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <PublicAnalytics />
      <App />
    </AuthProvider>
  </StrictMode>
);
